import { useQuery } from '@tanstack/react-query';
import { Field } from '@cloudsign/shared';
import { z } from 'zod';
import { api } from '../../lib/api';

const FieldList = z.array(Field);

/** Personal fields of a group (used by the drawer, bulk "set a field" and the import wizard). */
export function useGroupFields(groupId: string) {
  return useQuery({
    queryKey: ['members', 'fields', groupId],
    queryFn: () => api.get(`/fields/groups/${groupId}`, { schema: FieldList }),
    enabled: groupId !== '',
  });
}
